import { gql } from "@apollo/client";

const DATE_RULE_FIELDS = `
  mode
  fixedDate
  daysAfterToday
  daysAfterStart
  allowedDaysOfWeek
`;

const SELECTION_FIELDS = `
  sort {
    field
    direction
    valueOrder
  }
  preferred {
    mode
    items {
      id
      name
    }
  }
`;

export const CREATE_TRAVEL_DEALS_CONFIGURATION = gql`
  mutation CreateTravelDealsConfiguration($request: TravelDealsConfigurationRequestInput!) {
    createTravelDealsConfiguration(request: $request) {
      id
      name
      kind
      isEnabled
      maxOffers
      isAllCities
      cities
      citiesConfig {
        defaultRadiusKm
        cities {
          key
          name
          latitude
          longitude
          radiusKm
        }
      }
      flight {
        originAirport
        originAirportName
        destinationAirport
        destinationAirportName
        departureDateRule { ${DATE_RULE_FIELDS} }
        returnDateRule { ${DATE_RULE_FIELDS} }
        numberOfAdults
        passengerNationality
        searchType
        classFlight
        luggage
        selection { ${SELECTION_FIELDS} }
      }
      hotel {
        destinationId
        destinationName
        hotelId
        hotelName
        checkinDateRule { ${DATE_RULE_FIELDS} }
        numNights
        numAdults
        roomQuantity
        selection { ${SELECTION_FIELDS} }
      }
      car {
        pickupLocationCode
        pickupLocationName
        dropoffLocationCode
        dropoffLocationName
        locationType
        pickupDateRule { ${DATE_RULE_FIELDS} }
        dropoffDateRule { ${DATE_RULE_FIELDS} }
        pickupHour
        pickupMinutes
        dropoffHour
        dropoffMinutes
        selection { ${SELECTION_FIELDS} }
      }
    }
  }
`;

export const UPDATE_TRAVEL_DEALS_CONFIGURATION = gql`
  mutation UpdateTravelDealsConfiguration($id: UUID!, $request: TravelDealsConfigurationRequestInput!) {
    updateTravelDealsConfiguration(id: $id, request: $request) {
      id
      name
      kind
      isEnabled
      maxOffers
      isAllCities
      cities
      citiesConfig {
        defaultRadiusKm
        cities {
          key
          name
          latitude
          longitude
          radiusKm
        }
      }
      flight {
        originAirport
        originAirportName
        destinationAirport
        destinationAirportName
        departureDateRule { ${DATE_RULE_FIELDS} }
        returnDateRule { ${DATE_RULE_FIELDS} }
        numberOfAdults
        passengerNationality
        searchType
        classFlight
        luggage
        selection { ${SELECTION_FIELDS} }
      }
      hotel {
        destinationId
        destinationName
        hotelId
        hotelName
        checkinDateRule { ${DATE_RULE_FIELDS} }
        numNights
        numAdults
        roomQuantity
        selection { ${SELECTION_FIELDS} }
      }
      car {
        pickupLocationCode
        pickupLocationName
        dropoffLocationCode
        dropoffLocationName
        locationType
        pickupDateRule { ${DATE_RULE_FIELDS} }
        dropoffDateRule { ${DATE_RULE_FIELDS} }
        pickupHour
        pickupMinutes
        dropoffHour
        dropoffMinutes
        selection { ${SELECTION_FIELDS} }
      }
    }
  }
`;

export const SET_TRAVEL_DEALS_CONFIGURATION_ENABLED = gql`
  mutation SetTravelDealsConfigurationEnabled($id: UUID!, $isEnabled: Boolean!) {
    setTravelDealsConfigurationEnabled(id: $id, isEnabled: $isEnabled) {
      id
      isEnabled
    }
  }
`;

export const DELETE_TRAVEL_DEALS_CONFIGURATION = gql`
  mutation DeleteTravelDealsConfiguration($id: UUID!) {
    deleteTravelDealsConfiguration(id: $id)
  }
`;

export const CREATE_COMBO_OFFERS_CITY_CONFIGURATION = gql`
  mutation CreateComboOffersCityConfiguration($request: ComboOffersCityConfigurationRequestInput!) {
    createComboOffersCityConfiguration(request: $request) {
      id
      cityName
      isEnabled
      maxOffersPerType
      flights {
        maxOffers
        originAirport
        originAirportName
        destinationAirport
        destinationAirportName
        departureDateRule { ${DATE_RULE_FIELDS} }
        returnDateRule { ${DATE_RULE_FIELDS} }
        numberOfAdults
        passengerNationality
        searchType
        classFlight
        luggage
        selection { ${SELECTION_FIELDS} }
      }
      hotels {
        maxOffers
        destinationId
        destinationName
        checkinDateRule { ${DATE_RULE_FIELDS} }
        numNights
        numAdults
        roomQuantity
        selection { ${SELECTION_FIELDS} }
      }
      rentACars {
        maxOffers
        pickupLocationCode
        pickupLocationName
        dropoffLocationCode
        dropoffLocationName
        locationType
        pickupDateRule { ${DATE_RULE_FIELDS} }
        dropoffDateRule { ${DATE_RULE_FIELDS} }
        pickupHour
        pickupMinutes
        dropoffHour
        dropoffMinutes
        selection { ${SELECTION_FIELDS} }
      }
    }
  }
`;

export const UPDATE_COMBO_OFFERS_CITY_CONFIGURATION = gql`
  mutation UpdateComboOffersCityConfiguration($id: UUID!, $request: ComboOffersCityConfigurationRequestInput!) {
    updateComboOffersCityConfiguration(id: $id, request: $request) {
      id
      cityName
      isEnabled
      maxOffersPerType
      flights {
        maxOffers
        originAirport
        originAirportName
        destinationAirport
        destinationAirportName
        departureDateRule { ${DATE_RULE_FIELDS} }
        returnDateRule { ${DATE_RULE_FIELDS} }
        numberOfAdults
        passengerNationality
        searchType
        classFlight
        luggage
        selection { ${SELECTION_FIELDS} }
      }
      hotels {
        maxOffers
        destinationId
        destinationName
        checkinDateRule { ${DATE_RULE_FIELDS} }
        numNights
        numAdults
        roomQuantity
        selection { ${SELECTION_FIELDS} }
      }
      rentACars {
        maxOffers
        pickupLocationCode
        pickupLocationName
        dropoffLocationCode
        dropoffLocationName
        locationType
        pickupDateRule { ${DATE_RULE_FIELDS} }
        dropoffDateRule { ${DATE_RULE_FIELDS} }
        pickupHour
        pickupMinutes
        dropoffHour
        dropoffMinutes
        selection { ${SELECTION_FIELDS} }
      }
    }
  }
`;

export const SET_COMBO_OFFERS_CITY_CONFIGURATION_ENABLED = gql`
  mutation SetComboOffersCityConfigurationEnabled($id: UUID!, $isEnabled: Boolean!) {
    setComboOffersCityConfigurationEnabled(id: $id, isEnabled: $isEnabled) {
      id
      isEnabled
    }
  }
`;

export const DELETE_COMBO_OFFERS_CITY_CONFIGURATION = gql`
  mutation DeleteComboOffersCityConfiguration($id: UUID!) {
    deleteComboOffersCityConfiguration(id: $id)
  }
`;
